module.exports = __webpack_public_path__ + "img/bed.3d5308b8.svg";